import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class Brand extends BaseClass {
  Details: BaseClass;
  Merchants: BaseClass;
  constructor(obj: any = PERMISSIONS.Brand) {
    super(obj);
    this.Details = new BaseClass(obj.Details);
    this.Merchants = new BaseClass(obj.Merchants);
  }
}
